import { getMethod, postMethod, postMethodFormData } from "../apiService";

export const getPartnerRoles = async () => {
    try{
      const apiEndpoint = `/partner/role`
      const response = await getMethod(apiEndpoint)  
      return response
  } catch(error){
    console.log("API ERROR inside get partner roles", error);
  }
}
export const getPartnerUsers = async () => {
    try{
      const apiEndpoint = `/partner/users`
      const response = await getMethod(apiEndpoint)  
      return response
  } catch(error){
    console.log("API ERROR inside get partner users", error);
  }
}

export const updatePartnerUsers = async (userId: any, payload: any) => {
  try{
    const apiEndpoint = `/partner/update/${userId}`
    const response = await postMethodFormData(apiEndpoint, payload)  
    return response
} catch(error){
  console.log("API ERROR inside get partner users", error);
}
}

export const addBulkPartnerUsers = async (payload: any) => {
  try{
    const apiEndpoint = `/partner/register`
    const response = await postMethod(apiEndpoint, payload)  
    return response
} catch(error){
  console.log("API ERROR inside get partner users", error);
}
}
export const addPartnerUsers = async (payload: any) => {
  try{
    const apiEndpoint = `/partner/register`
    const response = await postMethod(apiEndpoint, payload)  
    return response
} catch(error){
  console.log("API ERROR inside get partner users", error);
}
}

export const ActivateAndSuspenduser = async (type: string, payload: string) => {
  const apiEndPoint = `central/user/${type}`
	try {
		const response = await postMethod(apiEndPoint, payload)
		return response;
	} catch (error) {
		console.log("API ERROR inside fetchAssignedSites", error);
	}
};
export const deletePartnerUsers = async (payload: any) => {
  try{
    const apiEndpoint = `central/user/remove`
    const response = await postMethod(apiEndpoint, payload)  
    return response
} catch(error){
  console.log("API ERROR inside get partner users", error);
}
}
